import React from 'react';

const CureusPromotionModal = ({handleAddWidget, widgetSidebarId}) => {

  const handleAddWidgetWrapper = () => {
    let params = {
      widget: {
        type: "Widget::CureusPromotionSidebar",
        parent_id: widgetSidebarId
      }
    }
    handleAddWidget(params)
  }

  return (
    <div className="reveal-modal small channel-design-modals" data-reveal>
      <div className="modal-body">
        <div className='modal-close'>
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
        <div className="modal-content middling">
          <div className="modal-header text-center">
            <h5>New Authors Hub Promotion</h5>
            <hr/>
          </div>
          <p>Insert a promotional ad for the <a target="_blank" href="https://www.cureus.com/authors_hub">New Authors Hub</a> to guide first-time authors through the article publishing process!</p>
          <div className='modal-footer text-center'>
            <a className={"button primary"} onClick={handleAddWidgetWrapper}>Add</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CureusPromotionModal;